var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_616_1016)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1726 17.1733C11.9071 19.4942 7.40786 18.9261 4.82109 15.8665C2.23432 12.807 2.42431 8.27569 5.25727 5.44184C8.09023 2.60888 12.6215 2.41889 15.682 5.00566C18.7424 7.59243 19.3097 12.0916 16.9887 15.3572L21 19.3685L19.1839 21.1846L15.1726 17.1733ZM14.3395 14.5232C16.3456 12.5171 16.3456 9.26402 14.3395 7.25704C12.3334 5.25006 9.08034 5.25095 7.07336 7.25704C5.06728 9.26313 5.06728 12.5162 7.07336 14.5232C9.07945 16.5302 12.3325 16.5293 14.3395 14.5232Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_616_1016"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.18457)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.2234e50bbdce3de24cd9a90599cafe6c.svg";
export { ForwardRef as ReactComponent };